// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import SliderController from "./slider_controller"
import HeaderController from "./header_controller"
import MobileDropdownController from "./mobile_dropdown_controller"
import TimelineNavController from "./timeline_nav_controller"
import GalleryController from "./gallery_controller"
import AgendaFilterController from "./agenda_filter_controller"
import ThemeController from "./theme_controller"
import ExpandController from "./expand_controller"

application.register("slider", SliderController)
application.register("header", HeaderController)
application.register("mobile-dropdown", MobileDropdownController)
application.register("timeline-nav", TimelineNavController)
application.register("gallery", GalleryController)
application.register("agenda-filter", AgendaFilterController)
application.register("theme", ThemeController)
application.register("expand", ExpandController)
